import * as React from "react";
import { StyledDividerWrapper } from "./styles";

interface DividerProps {
  content?: string | undefined;
  margin?: string | undefined;
}
export const Divider = ({ content, margin }: DividerProps) => {
  return (
    <StyledDividerWrapper style={{ margin: margin }}>
      <div></div>
      <>{content && <span>{content}</span>}</>
      <div></div>
    </StyledDividerWrapper>
  );
};
